<div class="flex gap-2 relative select-none">
  <!-- Sliding Background -->
  <div 
    #slider
    [ngClass]="{
      'tab-slider absolute top-0 bottom-0 rounded-full transition-all duration-300 ease-in-out pointer-events-none': true,
      'bg-primary-800': color() === 'primary',
      'bg-grey-950': color() === 'grey',
      'initialized': isViewInitialized()
    }"
  ></div>
  
  @for (tab of tabs(); track tab.value) {
    <button
      #tabBtn
      type="button"
      (click)="onTabClick(tab.value)"
      [ngClass]="{
        'relative cursor-pointer z-10 px-4 py-2 text-sm font-medium rounded-full transition-colors duration-300 ease-in-out': true,
        'text-white': activeTab() === tab.value,
        'text-neutral-950': activeTab() !== tab.value,
        'bg-primary-0 hover:bg-primary-100': activeTab() !== tab.value && color() === 'primary',
        'bg-grey-50 hover:bg-grey-100': activeTab() !== tab.value && color() === 'grey'
      }"
    >
      {{ tab.label }}
    </button>
  }
</div>
